import axios from "axios";
import { toast } from "react-toastify";

export const GET_ANNONCES = "GET_ANNONCES";
export const GET_ANNONCES_BY_USER = "GET_ANNONCES_BY_USER";
export const CREATE_ANNONCE = "CREATE_ANNONCE";
export const DELETE_ANNONCE = "DELETE_ANNONCE";
export const ADD_TO_FAVORITES = "ADD_TO_FAVORITES";
export const REMOVE_FROM_FAVORITES = "REMOVE_FROM_FAVORITES";
export const GET_ANNONCES_FAVORIS = "GET_ANNONCES_FAVORIS";


export const getAnnoncesParCategorie = (categorieId, page = 1, limit = 10) => {
  return (dispatch) => {
    return axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/annonce/categorie/id/${categorieId}?page=${page}&limit=${limit}`
      )
      .then((res) => {
        dispatch({ type: GET_ANNONCES, payload: res.data });
      })
      .catch((err) => {
        console.error("Erreur dans getAnnoncesParCategorie:", err.response?.data || err.message);
      });
  };
};

export const getAnnoncesByUser = (userId) => {
  return (dispatch) => {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/api/annonce/utilisateur/${userId}`)
      .then((res) => {
        dispatch({ type: GET_ANNONCES_BY_USER, payload: res.data });
      })
      .catch((err) => console.error("Erreur dans getAnnoncesByUser:", err));
  };
};

export const createAnnonce = (formData) => {
  return async (dispatch) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/annonce/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      dispatch({ type: CREATE_ANNONCE, payload: res.data });
      return res.data; 
    } catch (err) {
      if (err.response?.data?.errors) {
        return { errors: err.response.data.errors };
      }
    }
  };
};

export const deleteAnnonce = (id) => {
  return (dispatch) => {
    return axios
      .delete(`${process.env.REACT_APP_API_URL}/api/annonce/${id}`)
      .then((res) => {
        dispatch({ type: DELETE_ANNONCE, payload: id });
      })
      .catch((err) => {
        console.error(
          "Erreur lors de la suppression :",
          err.response?.data || err.message
        );
      });
  };
};

export const addToFavorites = (userId, annonceId) => {
  return (dispatch) => {
    return axios
      .post(`${process.env.REACT_APP_API_URL}/api/annonce/addToFavorites`, {
        userId,
        annonceId,
      })
      .then((res) => {
        dispatch({ type: ADD_TO_FAVORITES, payload: { userId, annonceId } });
        toast.success("Annonce ajoutée aux favoris !");
      })
      .catch((err) => {
        console.error(
          "Erreur lors de l'ajout aux favoris :",
          err.response?.data || err.message
        );
      });
  };
};

export const removeFromFavorites = (userId, annonceId) => {
  return (dispatch) => {
    console.log("Retirer des favoris:", userId, annonceId);
    return axios
      .put(
        `${process.env.REACT_APP_API_URL}/api/annonce/${userId}/favoris/${annonceId}/remove`
      )
      .then((res) => {
        dispatch({
          type: REMOVE_FROM_FAVORITES,
          payload: { userId, annonceId },
        });
        toast.info("Annonce retirée des favoris.");
      })
      .catch((err) => {
        console.error(
          "Erreur lors du retrait des favoris :",
          err.response?.data || err.message
        );
      });
  };
};

export const getAnnoncesFavoris = (userId) => {
  return (dispatch) => {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/api/annonce/${userId}/favoris`)
      .then((res) => {
        dispatch({ type: GET_ANNONCES_FAVORIS, payload: res.data });
      })
      .catch((err) =>
        console.error("Erreur dans getAnnoncesFavoris:", err.response?.data || err.message)
      );
  };
};